module.exports = __webpack_public_path__ + "static/media/standard_WWW.6376cd75.jpg";